import { connect } from 'react-redux';
import Searchbox from './SearchBox';

const mapStateToProps = ({
  content: { searchBox },
  intl: { locale },
  system: { siteName, isMobile }
}) => ({
  domain: siteName,
  site: siteName,
  locale,
  isMobile,
  ...searchBox
});

export default connect(mapStateToProps)(Searchbox);



// WEBPACK FOOTER //
// ./src/universal/components/SearchBox/index.js